import { Table, Typography } from 'antd';
import { t } from '@/utils/translator';

const { Title, Paragraph } = Typography;
const { Column } = Table;

const FeedbackTable = ({ row, feedbacks }) => {
  return (
    <>
      <Title level={5}>{t('피드백')}</Title>

      {row.cycle_feedback_comment && row.cycle_feedback_id && (
        <Paragraph>{row.cycle_feedback_comment}</Paragraph>
      )}

      {feedbacks.length > 0 && (
        <Table
          dataSource={feedbacks}
          rowKey="key"
          size="small"
          pagination={false}
          bordered
          className="my-4"
        >
          <Column title={t('첨부항목')} dataIndex="attachment_type" key="attachment_type" />
          <Column title={t('파일명')} dataIndex="filename" key="filename" />
          <Column
            title={t('피드백')}
            dataIndex="feedback"
            key="feedback"
            render={(text) => <div className="" dangerouslySetInnerHTML={{ __html: text }}></div>}
          />
        </Table>
      )}
    </>
  );
};

export default FeedbackTable;
